"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// debounce function to limit the amount of firing callbacks
var debounce = function debounce(func, wait, immediate) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var timeout = void 0;

  return function () {
    var context = undefined;

    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

exports.default = debounce;